import React, { useState, useEffect, useRef } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, CircularProgress, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
const CredentialEditModel = ({ open, onClose, credential, onSave }) => {
  const [formData, setFormData] = useState(credential || {});
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const originalDataRef = useRef(credential);

  useEffect(() => {
    if (credential) {
      setFormData(credential);
      setImagePreview(credential.CredentialImageURL || null);
      originalDataRef.current = credential;
    }
  }, [credential]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setFormData({ ...formData, CredentialImageURL: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClearImage = () => {
    setImagePreview(null);
    setFormData({ ...formData, CredentialImageURL: null });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const updatedData = { CredentialID: formData.CredentialID };
    for (const key in formData) {
      if (formData[key] !== originalDataRef.current[key]) {
        updatedData[key] = formData[key];
      }
    }
    await onSave(updatedData);
    setLoading(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Edit Credential</DialogTitle>
      <DialogContent>
        <TextField
          label="Credential Name"
          name="CredentialName"
          value={formData.CredentialName || ''}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Credential Description"
          name="CredentialDescription"
          value={formData.CredentialDescription || ''}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Credential Criteria"
          name="CredentialCriteria"
          value={formData.CredentialCriteria || ''}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <Box marginY={2}>
          <Typography variant="subtitle1">Update Credential Image</Typography>
          <input
            accept="image/*"
            type="file"
            onChange={handleImageChange}
            style={{ display: 'none' }}
            id="upload-image"
          />
          <label htmlFor="upload-image">
            <Button variant="contained" component="span">
              Upload Image
            </Button>
          </label>
          {imagePreview && (
            <Box marginTop={2}>
              <Typography variant="body2">Image Preview:</Typography>
              <img src={imagePreview} alt="Preview" style={{ maxWidth: '100%', maxHeight: '100px', marginTop: '8px', marginLeft: '8px' }} />
              <IconButton onClick={handleClearImage} aria-label="clear image" style={{ marginLeft: '8px', top: 0 }}>
                <CloseIcon />
              </IconButton>
            </Box>
          )}
        </Box>
        <TextField
          label="Credential Category"
          name="CredentialCategory"
          value={formData.CredentialCategory || ''}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Credential Type"
          name="CredentialType"
          value={formData.CredentialType || ''}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Credential Group Name"
          name="CredentialGroupName"
          value={formData.CredentialGroupName || ''}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button onClick={handleSubmit} color="primary" disabled={loading}>
          {loading ? (
            <>
              <CircularProgress size={20} style={{ marginRight: 8 }} color="inherit" />
              Updating...
            </>
          ) : (
            "Update"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CredentialEditModel;